import React from 'react';
import uniq from 'lodash.uniq';

import { useAppSelector } from 'js/store/hooks';
import { DEFAULT_ERASE_CURSOR_ID, NO_CURSOR_ID } from 'js/config/consts';

import HandMenu from '../AnimationPanels/HandMenu';
import { useAnimationStageContext } from '../AnimationPanels/AnimationStageContext';

export default function EraseHandPicker() {
  const { currentSelectedCursor, onAnimationCursorChoice } = useAnimationStageContext();

  const hands = useAppSelector(state => state.cursors.handErase);
  const filters = ['none', 'all', ...uniq(hands.map(hand => hand.group.toLowerCase()).sort())];

  const handleFilterChange = (filterName: string) => {
    if (filterName === 'none') {
      onAnimationCursorChoice(NO_CURSOR_ID);
    }
  };

  return (
    <HandMenu
      hands={hands}
      onSelection={onAnimationCursorChoice}
      selectedCursorId={currentSelectedCursor}
      defaultCursorId={DEFAULT_ERASE_CURSOR_ID}
      defaultCursorGroup="all"
      filters={filters}
      onFilterChange={handleFilterChange}
    />
  );
}
